import styled from 'styled-components'
import { Icon } from '../icon'
import { Tooltip } from '../tooltip'
import { CopyProps } from './copy.types'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const DEFAULT_AUTO_CLOSE_TIMEOUT = 1500
const TEXT_VARIANT_UNDERLINE_PADDING = '2px'

const CopyContainer = styled.div<{ reversed?: boolean }>`
  ${({ theme, reversed }) => `
    display: flex;
    align-items: center;
    gap: ${theme.sizes.xs};

    ${reversed && 'flex-direction: row-reverse;'}
  `}
`

const CopyButton = styled.button<{
  variant: NonNullable<CopyProps['variant']>
}>`
  ${({ theme, variant }) => `
    display: flex;
    align-items: center;
    gap: ${theme.sizes.xs};
    border-radius: ${variant === 'text' ? 0 : theme.sizes.xs};
    border: ${
      variant === 'text' ? 'none' : `1px solid ${theme.colors.gray200}`
    };
    padding: ${variant === 'text' ? 0 : '5px'};
    background: none;
    color: ${theme.colors.gray600};

    :hover {
      color: ${theme.colors.gray700};

      svg {
        & path {
          fill: ${theme.colors.gray700};
        }
      }
    }

    ${
      variant === 'text'
        ? `
          border-bottom: 1px solid ${theme.colors.gray600};
          padding-bottom: ${TEXT_VARIANT_UNDERLINE_PADDING};
        `
        : ''
    }
  `}
`

export function Copy({
  text,
  message = 'Copied',
  autoCloseTimeout = DEFAULT_AUTO_CLOSE_TIMEOUT,
  children,
  withIcon = true,
  className,
  reversed = false,
  btnLabel,
  variant = 'default',
}: Readonly<CopyProps>) {
  return (
    <CopyToClipboard text={text}>
      <CopyContainer reversed={reversed}>
        {children}
        <Tooltip content={message} trigger="click" autoClose={autoCloseTimeout}>
          <CopyButton
            data-testid="copy-content-button"
            className={className}
            type="button"
            variant={variant}
          >
            {btnLabel}
            {withIcon && <Icon name="copy" size={5} color="gray600" />}
          </CopyButton>
        </Tooltip>
      </CopyContainer>
    </CopyToClipboard>
  )
}
